// extracted by mini-css-extract-plugin
module.exports = {"button":"SocketStatus_button__25h7k","content":"SocketStatus_content__3aKQw","header":"SocketStatus_header__T35sX","wrapper":"SocketStatus_wrapper__3JDXi"};